/**
 * API utility functions for NWGSV Command System
 * Handles API calls with credentials
 */

// Use empty string for relative API calls (handled by Kubernetes ingress)
const API_URL = '';

/**
 * Format FastAPI error details for display
 * FastAPI validation errors return arrays, not strings
 */
export function formatApiErrorDetail(detail: any): string {
  if (detail == null) return 'Something went wrong. Please try again.';
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((e) => (e && typeof e.msg === 'string' ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(' ');
  }
  if (detail && typeof detail.msg === 'string') return detail.msg;
  return String(detail);
}

/**
 * Make authenticated API call
 */
export async function apiCall(
  endpoint: string,
  options: RequestInit = {}
): Promise<Response> {
  const url = endpoint.startsWith('http') ? endpoint : `${API_URL}${endpoint}`;
  
  return fetch(url, {
    ...options,
    credentials: 'include', // Send cookies
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
}
